import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VuexPersistence from 'vuex-persist';

// Store modules
import client from './modules/client';
import address from './modules/address';
import room from './modules/room';
import addition from './modules/addition';

Vue.use(Vuex);

const LOCAL_STORAGE_KEY = 'intake';

const vuexLocal = new VuexPersistence({
  key: LOCAL_STORAGE_KEY,
  storage: window.localStorage,
});

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    client,
    address,
    room,
    addition,
  },

  state: {
    isLoading: false,
    csrfToken: null,
    activeTab: '',
    clientErrors: [],
    addressErrors: [],
    roomErrors: [],
    additionErrors: [],
    currentSite: '',
    containers: [],
    i18n: {},
  },

  getters: {
    isLoading: (state) => state.isLoading,
    csrfToken: (state) => state.csrfToken,
    activeTab: (state) => state.activeTab,
    clientErrors: (state) => state.clientErrors,
    addressErrors: (state) => state.addressErrors,
    roomErrors: (state) => state.roomErrors,
    additionErrors: (state) => state.additionErrors,
    currentSite: (state) => state.currentSite,
    containers: (state) => state.containers,
    reserveContainerPage: (state) => state.reserveContainerPage,
    i18n: (state) => state.i18n,
  },

  actions: {
    async submit({ state, commit }) {
      commit('resetErrors');
      commit('setIsLoading', true);

      try {
        const response = await axios.post('/api/intake', {
          client: {
            ...state.client.client,
            project: state.client.project,
          },
          addresses: state.address.addresses,
          rooms: state.room.rooms,
          additions: state.addition.additions,
        });

        const data = await response.data;

        window.localStorage.removeItem(LOCAL_STORAGE_KEY);
        window.location.href = data.redirectTo;
      } catch (error) {
        const { data } = error.response;
        commit('setIsLoading', false);

        commit('setErrors', ['clientErrors', data.clientErrors]);
        commit('setErrors', ['addressErrors', data.addressErrors]);
        commit('setErrors', ['roomErrors', data.roomErrors]);
        commit('setErrors', ['additionErrors', data.additionErrors]);
      }

      return true;
    },
  },

  mutations: {
    hydrate(state, obj) {
      state.csrfToken = obj.csrfToken;
      state.currentSite = obj.currentSite;
      state.containers = JSON.parse(obj.containers);
      state.reserveContainerPage = obj.reserveContainerPage;
      state.i18n = JSON.parse(obj.i18n);

      if (state.activeTab === '' && state.currentSite === 'inboedelopslag') {
        state.activeTab = 'intake';
      } else {
        state.activeTab = 'client';
      }
    },

    setActiveTab(state, tab) {
      state.activeTab = tab;
    },

    setErrors(state, [key, errors]) {
      if (typeof errors === 'undefined') {
        state[key] = []; return;
      }

      state[key] = Object.values(errors);
    },

    setIsLoading(state, loading) {
      state.isLoading = loading;
    },

    resetErrors(state) {
      state.clientErrors = [];
      state.addressErrors = [];
      state.roomErrors = [];
      state.additionErrors = [];
    },
  },

  plugins: [
    vuexLocal.plugin,
  ],
});
